"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InventoryArticle = void 0;
var lib_1 = require("../lib");
var RichArticle_1 = require("./RichArticle");
var InventoryArticle = /** @class */ (function (_super) {
    __extends(InventoryArticle, _super);
    function InventoryArticle(params) {
        var _a, _b, _c;
        var _this = _super.call(this, params) || this;
        _this.selected = params.selected || false;
        _this.newPrice = params.newPrice;
        _this.newQuantity = params.newQuantity;
        _this.newComment = params.newComment;
        _this.newCondition = params.newCondition;
        _this.failedAutopricing = params.failedAutopricing;
        _this.readyToPublish = params.readyToPublish;
        _this.published = params.published;
        _this.listedAt = (_c = (_a = params.listedAt) !== null && _a !== void 0 ? _a : (_b = params.attributes) === null || _b === void 0 ? void 0 : _b[12]) !== null && _c !== void 0 ? _c : undefined;
        return _this;
    }
    Object.defineProperty(InventoryArticle.prototype, "currentPrice", {
        get: function () {
            if (typeof this.newPrice === 'number') {
                return this.newPrice;
            }
            return this.price;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InventoryArticle.prototype, "currentQuantity", {
        get: function () {
            if (typeof this.newQuantity === 'number') {
                return this.newQuantity;
            }
            return this.quantity;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InventoryArticle.prototype, "currentComment", {
        get: function () {
            if (typeof this.newComment === 'string') {
                return this.newComment;
            }
            return this.comment;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InventoryArticle.prototype, "hasNewComment", {
        get: function () {
            return typeof this.newComment === 'string' && this.newComment !== this.comment;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InventoryArticle.prototype, "currentCondition", {
        get: function () {
            if (typeof this.newCondition === 'string') {
                return this.newCondition;
            }
            return this.condition;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InventoryArticle.prototype, "realNewComment", {
        get: function () {
            if (!(typeof this.newComment === 'string'))
                return this.newComment;
            if (this.branded) {
                return (0, lib_1.getBrandedComment)(this.newComment);
            }
            else {
                return this.newComment.trim() ? this.newComment : '';
            }
        },
        enumerable: false,
        configurable: true
    });
    InventoryArticle.prototype.toggleSelected = function () {
        this.selected = !this.selected;
    };
    InventoryArticle.prototype.applyChanges = function () {
        return new RichArticle_1.RichArticle(__assign(__assign({}, this.toPlainObject()), { price: this.currentPrice, comment: this.currentComment, condition: this.currentCondition, quantity: this.currentQuantity }));
    };
    InventoryArticle.prototype.revertChanges = function () {
        this.newComment = undefined;
        this.newQuantity = undefined;
        this.newCondition = undefined;
        this.newPrice = undefined;
    };
    InventoryArticle.prototype.isEdited = function () {
        return (this.newPrice !== undefined ||
            this.newQuantity !== undefined ||
            this.newComment !== undefined ||
            this.newCondition !== undefined);
    };
    /**e
     * xcludes quantity
     */
    InventoryArticle.prototype.hasEditedAttribute = function () {
        return ((this.newPrice !== undefined && this.newPrice !== this.price) ||
            this.newComment !== undefined ||
            this.newCondition !== undefined);
    };
    InventoryArticle.prototype.toPlainObject = function () {
        return __assign(__assign({}, _super.prototype.toPlainObject.call(this)), { card: this.card, selected: this.selected, newPrice: this.newPrice, newQuantity: this.newQuantity, newComment: this.newComment, newCondition: this.newCondition, failedAutopricing: this.failedAutopricing, readyToPublish: this.readyToPublish, published: this.published, listedAt: this.listedAt });
    };
    InventoryArticle.prototype.copy = function () {
        return new InventoryArticle(__assign({}, this.toPlainObject()));
    };
    return InventoryArticle;
}(RichArticle_1.RichArticle));
exports.InventoryArticle = InventoryArticle;
//# sourceMappingURL=InventoryArticle.js.map